import * as ReduxToolkit from "@reduxjs/toolkit";
import { ManualRow } from "../../api";

export interface State {
    manuals?: ManualRow[];
}

export function initState(): State {
    return {};
}

export const manualSlice = ReduxToolkit.createSlice({
    name: "manuals",
    initialState: initState(),
    reducers: {
        resetState: (state) => {
            state = initState();
            return state;
        },
        updateManuals: (
            state,
            action: ReduxToolkit.PayloadAction<ManualRow[]>
        ) => {
            state.manuals = action.payload;
            return state;
        },
    },
});
